import { DatePipe } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';
import { ProgramTypesGUID } from '../../../../models/_enum-collections';
import { BlobFileDownloadRequestModel } from '../../../../models/blob-file-sas-url.model';
import {
  DownloadCSV,
  AllEventMilestone2Data
} from '../../../../models/download-csv.model';
import { CommonSharedModule } from '../../../common/shared.module';
import { ExportService } from '../../../services/export.service';
import { EventDownloadCSVService } from '../../../services/event-download-csv.service';

@Component({
  selector: 'app-event-download-csv',
  templateUrl: './download-csv.component.html',
  styleUrls: ['./download-csv.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonSharedModule]
})
export class EventDownloadCsvComponent implements OnInit {
  isLoading = true;
  downloadCSVList!: DownloadCSV[];
  loadingIcon = 'fa-circle-o-notch';
  selectedItem!: DownloadCSV;
  cols!: any[];
  m2Cols: any = [];
  alleventsmilestone2Data!: AllEventMilestone2Data[];

  constructor(
    private eventDownloadCsvService: EventDownloadCSVService,
    private exportService: ExportService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.getDownloadCSVList();
    this.getMilestone2Data();

    this.m2Cols = [
      { field: 'eventRegistrationID', header: 'EventRegistrationID' },
      { field: 'eventKey', header: 'Event Key' },
      { field: 'eventName', header: 'Event Name' },
      { field: 'categoryName', header: 'Category Name' },
      { field: 'customerName', header: 'Customer Name' },
      { field: 'tenantId', header: 'TenantId' },
      { field: 'partnerInputCustomerName', header: 'PartnerInputCustomerName' },
      {
        field: 'partnerInputValidationDetails',
        header: 'PartnerInputValidationDetails'
      },
      {
        field: 'partnerInputValidationType',
        header: 'PartnerInputValidationType'
      },
      { field: 'requestDate', header: 'RequestDate' },
      { field: 'fiscalYear', header: 'FiscalYear' },
      { field: 'dateSubmittedPST', header: 'DateSubmittedPST' },
      { field: 'eventStatus', header: 'EventStatus' },
      { field: 'partnerOneId', header: 'PartnerOneId' },
      { field: 'partnerLocation', header: 'PartnerLocation' },
      { field: 'pmoConfirmedPartnerID', header: 'PMO Confirmed PartnerID' },
      {
        field: 'pmoConfirmedPartnerName',
        header: 'PMO Confirmed Partner Name'
      },
      { field: 'payeeID', header: 'Payee ID' },
      { field: 'payeeName', header: 'Payee Name' },
      { field: 'submittedDate', header: 'Submitted Date' },
      { field: 'l1InternalStatusName', header: 'L1 Internal Status Name' },
      { field: 'workshopCompletionDate', header: 'Workshop Completion Date' },
      { field: 'poeCompletionDate', header: 'POE Completion Date' },
      { field: 'eventPoeStatusName', header: 'Event Poe StatusName' },
      { field: 'eventCompletionDate', header: 'Event Completion Date' },
      { field: 'scheduledEventDate', header: 'Scheduled EventDate' },
      { field: 'incentiveStatus', header: 'Incentive Status' },
      { field: 'paymentType', header: 'PaymentType' },
      { field: 'tier1PaymentAmount', header: 'Tier1 PaymentAmount' },
      { field: 'tier1MetDate', header: 'Tier1 MetDate' },
      { field: 'tier1PaidDate', header: 'Tier1 PaidDate' },
      { field: 'tier1MaturityDate', header: 'Tier1 MaturityDate' },
      { field: 'tier1MaturityStatus', header: 'Tier1 MaturityStatus' },
      { field: 'tier1Target', header: 'Tier1 Target' },
      { field: 'tier1MSInvoiceNumber', header: 'Tier1 MSInvoiceNumber' },
      { field: 'tier1MSInvoiceDate', header: 'Tier1 MSInvoiceDate' },
      {
        field: 'tier1PaymentCentralTransactionID',
        header: 'Tier1 PaymentCentral TransactionID'
      },
      {
        field: 'tier1PaymentDocumentNumber',
        header: 'Tier1 PaymentDocumentNumber'
      },
      { field: 'tier2PaymentAmount', header: 'Tier2 PaymentAmount' },
      { field: 'tier2MetDate', header: 'Tier2 MetDate' },
      { field: 'tier2PaidDate', header: 'Tier2 PaidDate' },
      { field: 'tier2MaturityDate', header: 'Tier2 MaturityDate' },
      { field: 'tier2MaturityStatus', header: 'Tier2 MaturityStatus' },
      { field: 'tier2Target', header: 'Tier2 Target' },
      { field: 'tier2MSInvoiceNumber', header: 'Tier2 MSInvoiceNumber' },
      { field: 'tier2MSInvoiceDate', header: 'Tier2 MSInvoiceDate' },
      {
        field: 'tier2PaymentCentralTransactionID',
        header: 'Tier2 PaymentCentral TransactionID'
      },
      {
        field: 'tier2PaymentDocumentNumber',
        header: 'Tier2 Payment DocumentNumber'
      }
    ];
  }
  getDownloadCSVList() {
    this.eventDownloadCsvService
      .getDownloadCSVFilesList(ProgramTypesGUID.Events)
      .subscribe(downloadCsvListResponse => {
        this.downloadCSVList = downloadCsvListResponse;
        this.isLoading = false;
        this.changeDetectorRef.markForCheck();
      });
  }

  getMilestone2Data() {
    const dp = new DatePipe('en-US');
    const format = 'MM/dd/yyyy';
    this.isLoading = true;
    this.eventDownloadCsvService
      .getAllEventsMilestone2Data()
      .subscribe(data => {
        this.alleventsmilestone2Data = data;
        this.alleventsmilestone2Data.forEach(element => {
          element.eventCompletionDate =
            dp.transform(element.eventCompletionDate, format) || '';
          element.submittedDate =
            dp.transform(element.submittedDate, format) || '';
          element.workshopCompletionDate =
            dp.transform(element.workshopCompletionDate, format) || '';
          element.poeCompletionDate =
            dp.transform(element.poeCompletionDate, format) || '';
          element.scheduledEventDate =
            dp.transform(element.scheduledEventDate, format) || '';
          element.tier1MetDate = dp.transform(element.tier1MetDate, format);
          element.tier1PaidDate = dp.transform(element.tier1PaidDate, format);
          element.tier1MaturityDate = dp.transform(
            element.tier1MaturityDate,
            format
          );
          element.tier1MSInvoiceDate = dp.transform(
            element.tier1MSInvoiceDate,
            format
          );

          element.tier2MetDate = dp.transform(element.tier2MetDate, format);
          element.tier2PaidDate = dp.transform(element.tier2PaidDate, format);
          element.tier2MaturityDate = dp.transform(
            element.tier2MaturityDate,
            format
          );
          element.tier2MSInvoiceDate = dp.transform(
            element.tier2MSInvoiceDate,
            format
          );
        });
        this.isLoading = false;
        this.changeDetectorRef.markForCheck();
      });
  }

  downloadFile(selectedFile: DownloadCSV) {
    const blobFileDownloadRequestModel: BlobFileDownloadRequestModel = {
      fileName: selectedFile.fileName || '',
      fileUrl: selectedFile.url || ''
    };

    this.eventDownloadCsvService
      .downloadCSVFile(blobFileDownloadRequestModel)
      .subscribe(downloadFileSasUrl => {
        window.location.href = downloadFileSasUrl;
      });
  }

  payeeIdPaymentReport(haspayeeId: boolean) {
    this.eventDownloadCsvService
      .exportPayeePaymentReport(haspayeeId)
      .subscribe(exceldata => {
        if (exceldata.length > 0) {
          const docname =
            haspayeeId == true
              ? 'Events_Ready For Payment'
              : 'Events_No Payee Id Ready For Payment';
          this.exportService.exportExcel(exceldata, docname);
        }
      });
  }
  exportNoPayeeIDPaymentReport() {
    this.payeeIdPaymentReport(false);
  }
  exportReadyforPaymentReport() {
    this.payeeIdPaymentReport(true);
  }
  exportAllEventMilestone2() {
    if (this.alleventsmilestone2Data.length > 0) {
      const docname = 'All Events Milestone 2';
      this.exportService.exportToCsv(this.alleventsmilestone2Data, docname);
    }
  }
}
